import React from "react";
import { image_path } from "../../environment";

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
}

const ImageWithBasePath = (props: Image) => {
  // Combine the base path and the provided src to create the full image source URL
  const altText = String(props.alt);
  const fullSrc = `${image_path}${props.src}`;
  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={altText}
      width={props.width}
      id={props.id}
      onError={(e) => {
        e.currentTarget.src = "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
        e.currentTarget.style.height = "22px";
        e.currentTarget.style.width = "22px";
        e.currentTarget.style.marginRight = "10px";
      }}
    />
  );
};

export default ImageWithBasePath;
